// import { userActions } from "redux/actions";

const initialState = {
    users: []
}

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        
        default:
            return state;
    }
}

export default userReducer;